var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 12C18.75 12.4142 18.4142 12.75 18 12.75C17.5858 12.75 17.25 12.4142 17.25 12C17.25 11.5858 17.5858 11.25 18 11.25C18.4142 11.25 18.75 11.5858 18.75 12Z",
    fill: "#292556"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.02 9H20.98M13.5 12H15.5M10.2 20H13.8C16.7998 20 18.2997 20 19.3511 19.2361C19.6907 18.9893 19.9893 18.6907 20.2361 18.3511C21 17.2997 21 15.7998 21 12.8V11.2C21 8.20021 21 6.70032 20.2361 5.64886C19.9893 5.30928 19.6907 5.01065 19.3511 4.76393C18.2997 4 16.7998 4 13.8 4H10.2C7.20021 4 5.70032 4 4.64886 4.76393C4.30928 5.01065 4.01065 5.30928 3.76393 5.64886C3 6.70032 3 8.20021 3 11.2V12.8C3 15.7998 3 17.2997 3.76393 18.3511C4.01065 18.6907 4.30928 18.9893 4.64886 19.2361C5.70032 20 7.20021 20 10.2 20Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit-card.244eedf566122485fb1a2c45524d0d41.svg";
export { ForwardRef as ReactComponent };